import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { DiscoveryChatQuestion, PossibleResponse, ChatConsultant, ChatRollMessage, ChatUser, ChatUserType } from '../model/discovery-chat.interface';
import { sortBy, floor } from 'lodash';
import { DoneDiscoveryProcessComponent } from '../done-discovery-process/done-discovery-process.component';
import { DiscoveryStatusEnum } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AbstractDiscoveryProcessService } from '../discovery-process.abstract.service';
import { Router } from '@angular/router';
import { NAVIGATION_ROUTES } from 'src/app/navigation-routes.const';
import { AbstractAuthorizationService } from 'src/app/moov-common/services/authorization/authorization.abstract.service';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { UtilsService } from 'src/app/moov-common/services/utils/utils.service';
import { firstValueFrom } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
@Component({
    selector: 'app-discovery-chat',
    templateUrl: './discovery-chat.component.html',
    styleUrls: ['./discovery-chat.component.scss'],
})

// const QUESTION_DISPLAY_DELAY_MS = 500;
export class DiscoveryChatComponent
    extends BaseComponent
    implements OnInit {
    @ViewChild('chatBody') chatBodyRef: ElementRef<HTMLDivElement>;
    questionList: DiscoveryChatQuestion[] = [];
    currentQuestionPos: number = 0;
    consultant: ChatConsultant = { id:"C001", name: "אביבית", title: "יועצת קריירה", photoURL: 'https://storage.googleapis.com/media.landbot.io/152285/channels/G3Y2NEP25EGJGBKL8J81MHWEMN1EGDB5.png', type: ChatUserType.Consultant };
    chatUser: ChatUser;
    answeredQuestionList: ChatRollMessage[] = [];
    isLoading: boolean = false;
    currentQuestionSetId: string = "";
    lastQuestionSetId: string = "";
    prevQuestionSetResponseToRemove: PossibleResponse[] = [];
    historicResponses: Map<string, PossibleResponse>;
    progressBarValue = 0;
    focusBottom = false;
    TOTAL_QUESTIONS_NUMBER = 66;
      
    constructor(private readonly discoveryProcessService: AbstractDiscoveryProcessService, 
                private router: Router, 
                public dialog: MatDialog, 
                private readonly authService: AbstractAuthorizationService,
                private readonly personalUserDataService: AbstractPersonalUserDataService,
                public utils: UtilsService
    ) {
        super();
        this.historicResponses=new Map<string, PossibleResponse>();
    }

    ngOnInit(): void {
        if (this.user) {
            if (this.user.discoveryStatus == DiscoveryStatusEnum.DONE){
                // the user has navigated here by mistake
                this.router.navigate([NAVIGATION_ROUTES.app.personalView]);
            }

            this.chatUser = {
                id: this.user.id,
                name: this.user.firstName + " " + this.user.lastName,
                photoURL: this.user.image ? this.user.image : "",
                type: ChatUserType.User,
                title: "", // TODO: convert user role to title?
            }

        try {
            this.discoveryProcessService.continueUserJourney().subscribe(response => {
                this.TOTAL_QUESTIONS_NUMBER = response.totalQuestions || 66;
                this.discoveryProcessService.journeyGetQuestionsInBatch().subscribe(batchResponse => {
                    // console.log(`getNextBatch pulled ${(batchResponse.length)} questions`);
                    this.questionList = batchResponse;
                    this.questionList = sortBy(this.questionList, ['batchIdx']);
                    
                    // console.log(`dis pro curr question is ${JSON.stringify(this.questionList)}` );

                    this.currentQuestionSetId = this.questionList[this.currentQuestionPos].setId;
                    this.setProgressBarValue();
                });
            });
            } catch (e) {
                console.log ('discovery-chat ngOnInit error in journeyGetQuestionsInBatch or continueUserJourney');
                // Reload page 
                window.location.reload();
            }
        }
    }

    setQuestionResponse(currentQuestion: DiscoveryChatQuestion) {
        this.showLoading();
        this.focusBottom = false;

        // let selectedResponses: PossibleResponse[] | undefined = filter(currentQuestion.possibleResponses, function (res: PossibleResponse) { return ((res.selected) && (res.questionId == currentQuestion.id)) });
        let selectedResponses: PossibleResponse[] = [];
        this.prevQuestionSetResponseToRemove = [];
        currentQuestion.possibleResponses.forEach(res => {
            if ((res.selected) && (res.questionId == currentQuestion.id)) {
                selectedResponses.push(res);
                this.prevQuestionSetResponseToRemove.push(res); // to remove in next set, if relevant
                this.historicResponses.set(currentQuestion.id, res); // save responses 
            }
        })

        if (selectedResponses !== undefined) { 
            let selectedResponseIds: string[] = selectedResponses.map(({ id }) => id);

            try{
                this.discoveryProcessService.journeySetQuestionResponse(currentQuestion.id, selectedResponseIds).subscribe(response => {
                    this.addQuestionToChatRoll(currentQuestion, selectedResponses);
                    this.showNextQuestion();
                });
            } catch (e) {
                console.log ('discovery-chat setQuestionResponse error in journeySetQuestionResponse');
                // Reload page 
                window.location.reload();
            }
        }

        this.setProgressBarValue();
    }

    setProgressBarValue(){
        // in the begining of the discovery process we want to present more progress
        // console.log (`discovery process progress currQuestion is ${JSON.stringify(this.questionList[this.currentQuestionPos])} total is ${this.TOTAL_QUESTIONS_NUMBER}`);
        const rawValue =  floor(this.questionList[this.currentQuestionPos].idx / this.TOTAL_QUESTIONS_NUMBER * 100);
     
        this.progressBarValue = rawValue;

        // console.log (`discovery process progress bar value is ${this.progressBarValue}`);

        // if (rawValue < 20){
        //     progressBarValue = 1.5 * rawValue;
        // }
        // else if (rawValue == 20 ){
        //     progressBarValue = 30;
        // }
        // else if (rawValue > 20 && rawValue < 30){
        //     progressBarValue = floor(1.4 * rawValue);
        // }
        // else if (rawValue == 30){
        //     progressBarValue = 43;
        // }
        // else if (rawValue >30 && rawValue < 40){
        //     progressBarValue = floor(1.3 * rawValue);
        // }
        // else if (rawValue == 40){
        //     progressBarValue = 52;
        // }
        // else if (rawValue > 40 && rawValue < 50){
        //     progressBarValue = floor(1.25 * rawValue);
        // }
    }

    selectDiffernetAnswer(){
        this.showLoading();

        this.currentQuestionPos--;
        this.questionList[this.currentQuestionPos].isAnswered = false;
        // console.log(`Showing question ${this.currentQuestionPos} out of ${this.questionList.length }`);

        if (this.currentQuestionPos == 0){
            // we have returned to the first question
            this.lastQuestionSetId = "";
        }
        else{
            this.lastQuestionSetId = this.questionList[this.currentQuestionPos-1].setId;
        }


        this.questionList[this.currentQuestionPos].possibleResponses.forEach((element: PossibleResponse) => {
            element.selected = false;
        });

        this.currentQuestionSetId = this.questionList[this.currentQuestionPos].setId;

        this.prevQuestionSetResponseToRemove = [];
        if (this.lastQuestionSetId == this.currentQuestionSetId) { // set was changed, no need to save previous set responses.
            let response = this.historicResponses.get(this.questionList[this.currentQuestionPos].id); // save responses 

            if (response != undefined){
                this.prevQuestionSetResponseToRemove.push(response); // to remove in next set, if relevant
            }
        }
        
        // remove data from chat roll  
        this.answeredQuestionList.pop(); // the last question
        this.answeredQuestionList.pop(); // the last response
        // this.answeredQuestionList.pop(); 

        this.hideLoading();
    }

    private addQuestionToChatRoll(currentQuestion: DiscoveryChatQuestion, selectedResponses?: PossibleResponse[]) {
        if (selectedResponses) {
            let displayedConsultantQuestion = false;
            selectedResponses.forEach(selectedResponse =>
            {
                
                let hour: number = new Date().getHours();
                let minutes: number = new Date().getMinutes();
                let timestamp: string = `${hour}:${minutes}`;

                if (!displayedConsultantQuestion) { // In case of multiple responses, we want to display the question once and below all the responses.
                    let chatRollMessageConsultant: ChatRollMessage = {
                        id: currentQuestion.id, participant: this.consultant, text: currentQuestion.questionText, timestamp
                    }
                    this.answeredQuestionList.push(chatRollMessageConsultant);
                    displayedConsultantQuestion = true;
                }
                
                let chatRollMessageUser: ChatRollMessage = {
                    id: currentQuestion.id, participant: this.chatUser, text: selectedResponse.responseText, timestamp
                }
            
                this.answeredQuestionList.push(chatRollMessageUser);
                    this.answeredQuestionList = ([] as ChatRollMessage[]).concat(this.answeredQuestionList);
                }
            )

            this.focusBottom = true;
        }
    } 

    private async showNextQuestion() {
        this.questionList[this.currentQuestionPos].isAnswered = true;
        if (this.currentQuestionPos < this.questionList.length- 1) {
            this.currentQuestionPos++;
            console.log(`DBG discoveryChat (!) show next Question`);
            this.hideLoading();
        } else {
            await this.getNextBatchOrDone();
            this.prevQuestionSetResponseToRemove = [];
        }
        this.lastQuestionSetId = this.currentQuestionSetId;
        this.currentQuestionSetId = this.questionList[this.currentQuestionPos].setId;
        if (this.lastQuestionSetId !== this.currentQuestionSetId) { // set was changed, no need to save previous set responses.
            this.prevQuestionSetResponseToRemove = [];
        }
        // console.log(`currQuestionId ${this.questionList[this.currentQuestionPos].id} currentQuestionSetId ${this.currentQuestionSetId } lastQuestionSetId ${this.lastQuestionSetId} prevQuestionSetResponseToRemove ${this.prevQuestionSetResponseToRemove}` );
    }

    private async getNextBatchOrDone() {
        // console.log(`getting next batch`);
        let batchResponse : any;
        
        try {
            batchResponse = await firstValueFrom(this.discoveryProcessService.journeyGetQuestionsInBatch());
        } catch (e) {
            console.log ('discovery-chat getNextBatchOrDone error in journeyGetQuestionsInBatch');
            // Reload page 
            window.location.reload();
        }

        if (batchResponse && batchResponse.length > 0) {
            // console.log(`batch added ${batchResponse.length} questions`);
            batchResponse = sortBy(batchResponse, ['batchIdx']);
            this.questionList = this.questionList.concat(batchResponse);
            // console.log(`after adding batch this.questionList.length: ${this.questionList.length}`);
            this.currentQuestionPos++;
            console.log(`DBG discovery chat (!) getNextBatchOrDone}`);
            this.hideLoading();
        } else {
            this.showDone();
        }
    }

    private showDone() {

    
    this.analytics.discoveryProcessCompletedEvent();

    this.authService.updateLoggedInUserToken().subscribe(res => {
        const dialogRef = this.dialog.open(DoneDiscoveryProcessComponent, {
            height: '40%',
            width: '60%'
        });
        
        dialogRef.afterClosed().subscribe( res =>{
            this.router.navigate([NAVIGATION_ROUTES.app.personalView]);
        });
    });
    }

    private showLoadingAndHide() {
        this.isLoading = true;
        const source = this.utils.delay(2);
        this.isLoading = false;
        
    }

    private showLoading() {
        this.isLoading = true;
    }

    private hideLoading() {
        this.isLoading = false;
    }

   scrollToBottom() {
    this.chatBodyRef.nativeElement.scrollTop = this.chatBodyRef.nativeElement.scrollHeight;
    // console.log(this.chatBodyRef.nativeElement.scrollTop);
    // this.chatBodyRef.nativeElement.scrollTo({left: 0 , top: this.chatBodyRef.nativeElement.scrollHeight, behavior: 'smooth'});
    // console.log(`scrolling down`);
  }

    // private getInitialAnsweredQuestionList(questionListPos: number): ChatRollMessage[] {
    //     let answeredQuestionList = slice(this.questionList, 0, questionListPos);
    //     console.log(`answeredQuestionList ${answeredQuestionList}`);
    //     console.log(`questionList ${this.questionList}`);
    //     let chatRollMessages: ChatRollMessage[] = [];
    //     answeredQuestionList.forEach(q => chatRollMessages.push({id: q.id, text:q.questionText, participant:this.consultant}));
    //     return answeredQuestionList;
    // }

}
 